var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"r-number-box",class:[
    ("r-number-box-" + _vm.align),
    {
      'is-readonly': _vm.readonly,
      'is-disabled': _vm.disabled
    }
  ],attrs:{"type":"text","pattern":_vm.sp ? '\\d*':'',"disabled":_vm.disabled || _vm.readonly,"placeholder":_vm.placeholder,"autocomplete":"off"},domProps:{"value":(_vm.model)},on:{"change":_vm.handleChange,"blur":_vm.handleBlur,"input":function($event){if($event.target.composing){ return; }_vm.model=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28f1381c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/r-elements/RNumberBox.vue
// module id = null
// module chunks = 